<div class="filter_list grid">
    <label class="inp_group">
        <div class="lbl">Id клиента</div>
        <input type="text" name="customerId" [(ngModel)]="customerFilter.id" class="inp" placeholder="id">
    </label>
    <label class="inp_group">
        <div class="lbl">Имя клиента</div>
        <input type="text" name="customerName" [(ngModel)]="customerFilter.name" class="inp" placeholder="John">
    </label>
    <label class="inp_group">
        <div class="lbl">Логин подписки</div>
        <input type="text" name="subscriptionLogin" [(ngModel)]="customerFilter.login" class="inp" placeholder="10001">
    </label>
    <label class="inp_group">
        <div class="lbl">Имейл</div>
        <input type="text" name="email" [(ngModel)]="customerFilter.email" class="inp" placeholder="test@test.com">
    </label>
    <label class="inp_group">
        <div class="lbl">Телефон</div>
        <input type="number" name="phone" [(ngModel)]="customerFilter.phone" class="inp" placeholder="380660249279">
    </label>
    <label class="inp_group" >
        <div class="lbl">Статусы</div>
        <select class="inp" name="statuses" (ngModelChange)="onSelectChange($event, 'statuses')"   [(ngModel)]="selectedStatus">
            <option [ngValue]="null">Все</option>
            <option *ngFor="let status of optionsStatus" [value]="status.id">{{status.name}}</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">Пользователи</div>
        <select class="inp" name="users" (ngModelChange)="onSelectChange($event, 'users')" [(ngModel)]="selectedUsers">
            <option [ngValue]="null">Все</option>
            <option *ngFor="let user of optionsUsers" [value]="user.id">{{user.name}}</option>
        </select>
    </label>
</div>